import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResponseHttpInterceptor implements HttpInterceptor{

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
    .pipe(tap( (evento: HttpEvent<any>) => {
      if (evento instanceof HttpResponse) {
        const bearerToken = evento.headers.get('authorization');
        const fechaExpiracion = evento.headers.get('date-expiration');

        if (bearerToken) {
          localStorage.setItem('token', bearerToken);
        }
        if (fechaExpiracion) {
          localStorage.setItem('fecha-expiracion', fechaExpiracion);
        }
      }
    }))
  }



}
